import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";

// переименовать хелпер на cloneLangObjectsToNonEmptyNames
export const cloneValue = (langObj: LangObject[]): LangObject[] => {
  const isEmpty = langObj?.some((i) => i?.name === '');

  if (isEmpty) {
      const lang = langObj?.find((i) => i?.name !== '');
      return langObj?.map((i) => ({ ...i, name: lang?.name || '' })) as LangObject[]
  }

  return langObj
}import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";

// переименовать хелпер на cloneLangObjectsToNonEmptyNames
export const cloneValue = (langObj: LangObject[]): LangObject[] => {
  const isEmpty = langObj?.some((i) => i?.name === '');

  if (isEmpty) {
      const lang = langObj?.find((i) => i?.name !== '');
      return langObj?.map((i) => ({ ...i, name: lang?.name || '' })) as LangObject[]
  }

  return langObj
}